import $ from 'jquery';
import axios from 'axios';
import styleSelect from 'styleselect';

const jsrender = require('jsrender')($);

$(document).ready(function () {
  const $parkingDirectory = $('.m-parking-directory');
  const $geoSearch = $parkingDirectory.find('.geo-search');
  const $geoSearchButton = $geoSearch.find('.e-button');

  const pageData = {};
  //
  if ($parkingDirectory.length === 0) {
    return;
  }

  LoadData();

  function LoadData() {

    axios.get("/common/discounts/countries").then(function (response) {
      pageData["countries"] = response.data.data;
      LoadPage();
    });

  }

  function LoadPage() {
    AddOnGeoButtonClick();
    LoadCountrySelector();
    $("#dataLoadingSpinner").remove();
  }

  function LoadCountrySelector() {
    const countriesDDTmpl = jsrender.templates('#countriesDDTmpl');
    const $dropdownCountry = $('.dropdown-country');
    const html = countriesDDTmpl.render(pageData);
    $dropdownCountry.html(html);
    RefreshSelectStyles($dropdownCountry);
    AddOnCountryChangeEvent();
  }

  function LoadCitySelector(country) {
    const citiesDDTmpl = jsrender.templates('#citiesDDTmpl');
    const $dropdownCity = $('.dropdown-city');
    const html = citiesDDTmpl.render(country);
    $dropdownCity.html(html);
    RefreshSelectStyles($dropdownCity);
    AddOnCityChangeEvent();
  }

  function LoadParkingsTable(city) {
    const parkinsTBLTmpl = jsrender.templates('#parkinsTBLTmpl');
    const $tableParkings = $('.table-parkings');
    const html = parkinsTBLTmpl.render(city);
    $tableParkings.html(html);
  }

  function LoadCountryParkings(country) {
    var allCountryParkings = {};
    allCountryParkings.parkings = [];
    country.cities.forEach(function (city) {
      allCountryParkings.parkings = allCountryParkings.parkings.concat(city.parkings);
    });
    LoadParkingsTable(allCountryParkings)
  }

  function AddOnCountryChangeEvent() {
    const $countrySelector = $parkingDirectory.find('.dropdown-country .e-select select');
    $countrySelector.on('change', function () {
      const selectedValue = $countrySelector.find('option:selected').val();
      const country = pageData.countries.find(c => c.countryId == selectedValue);
      if (country == undefined) {
        $("#CitySelector").remove();
        $("#ParkingsTable").remove();
      } else {
        LoadCitySelector(country);
        LoadCountryParkings(country);

      }
    });
  }

  function AddOnCityChangeEvent() {
    const $citySelector = $parkingDirectory.find('.dropdown-city .e-select select');
    const $countrySelector = $parkingDirectory.find('.dropdown-country .e-select select');
    $citySelector.on('change', function () {
      const selectedCityValue = $citySelector.find('option:selected').val();
      const selectedCountryValue = $countrySelector.find('option:selected').val();
      const country = pageData.countries.find(c => c.countryId == selectedCountryValue);
      const city = country.cities.find(c => c.cityId == selectedCityValue);
      if (city == undefined) {
        $("#ParkingsTable").remove();
        LoadCountryParkings(country);
      } else {
        LoadParkingsTable(city);
      }
    });
  }

  function AddOnGeoButtonClick() {
    $geoSearchButton.on('click', (event) => {
      event.preventDefault();
      const $posModal = $(`.e-modal[data-modal='no-position']`);
      if ('geolocation' in navigator) {
        navigator.geolocation.getCurrentPosition(
          function (position) {
            var myLngLat = { lng: position.coords.longitude, lat: position.coords.latitude };
            LoadNearbyParkings(myLngLat);
          },
          function (positionError) {
            $posModal.addClass('is-visible');
          },
          {
            maximumAge: 0,
            timeout: 5000
          }
        );
      } else {
        $posModal.addClass('is-visible');
      }
    });
  }

  function RefreshSelectStyles($select) {
    $select.each(function () {
      const $thisSelect = $(this);
      const $innerSelects = $thisSelect.find('select');

      $innerSelects.each(function () {
        const select = $(this)[0];
        styleSelect(select);
      });
    });
  }



  function LoadNearbyParkings(myLngLat) {
    var allParkings = {};
    allParkings.parkings = [];
    pageData.countries.forEach(function (country) {
      country.cities.forEach(function (city) {
        allParkings.parkings = allParkings.parkings.concat(city.parkings);
      });
    });

    var parkings = [];
    var nearbyParkings = {};
    nearbyParkings.parkings = [];
    allParkings.parkings.forEach(function (p) {
      var parking = Object.assign({}, p);
      var parkingLngLat = GetParkingCoordinates(parking);
      var parkingDistance = 10000000;
      if (parkingLngLat.lat != undefined && parkingLngLat.lng != undefined) {
        parkingDistance = CalculeParkingDistance(myLngLat, parkingLngLat);
        parking.name = parking.name + " (~ " + parkingDistance + " Km)";
      }
      //if (parkingDistance < 5) {      
      parking.distance = parkingDistance;
      parkings.push(parking);
      //}
    });
    $("#CitySelector").remove();
    $("#ParkingsTable").remove();
    LoadCountrySelector();
    nearbyParkings.parkings = parkings.sort((a, b) => (a.distance > b.distance) ? 1 : -1);
    LoadParkingsTable(nearbyParkings);
  }

  function GetParkingCoordinates(parking) {
    var geoCoords = getCoordsByUrl(/@(-?\d+\.\d+),(-?\d+\.\d+)/, parking.url);
    return geoCoords.lat === null || geoCoords.lng === null
      ? getCoordsByUrl(/\?q=(-?\d+\.\d+),(-?\d+\.\d+)/, parking.url)
      : geoCoords;
  }

  function getCoordsByUrl(regEx, parkingUrl) {
    var match = parkingUrl.match(regEx);
    if (match && match.length === 3) {
      return { lng: match[2], lat: match[1] };
    } else {
      return { lng: null, lat: null };
    }
  }

  function CalculeParkingDistance(myLngLat, parkingLngLat) {
    var rad = function (x) { return x * Math.PI / 180; }
    var R = 6378.137;                     //Radio de la tierra en km
    var dLat = rad(parkingLngLat.lat - myLngLat.lat);
    var dLong = rad(parkingLngLat.lng - myLngLat.lng);
    var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(rad(myLngLat.lat)) * Math.cos(rad(parkingLngLat.lat)) * Math.sin(dLong / 2) * Math.sin(dLong / 2);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    var distance = R * c;
    return parseInt(distance);

  }


});



// WEBPACK FOOTER //
// ./app/ui/modules/parking-directory/index.js